function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.75 22.16L16 19.16L17.16 18L18.75 19.59L22.34 16L23.5 17.41L18.75 22.16ZM12 2C17.5 2 22 6.5 22 12L21.92 13.31C21.31 13.11 20.67 13 19.94 13L20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C12.71 20 13.39 19.91 14.05 19.74C14.13 20.42 14.33 21.06 14.62 21.65C13.78 21.88 12.9 22 12 22C6.47 22 2 17.5 2 12C2 6.5 6.47 2 12 2Z",
  className: "icon-primary"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17 14.75V16H7V14.75C7 13.09 10.34 12.25 12 12.25C13.66 12.25 17 13.09 17 14.75Z",
  className: "icon-primary"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2322 6.73223C10.7011 6.26339 11.337 6 12 6C12.3283 6 12.6534 6.06466 12.9567 6.1903C13.26 6.31594 13.5356 6.50009 13.7678 6.73223C13.9999 6.96438 14.1841 7.23998 14.3097 7.54329C14.4353 7.84661 14.5 8.1717 14.5 8.5C14.5 8.8283 14.4353 9.15339 14.3097 9.45671C14.1841 9.76002 13.9999 10.0356 13.7678 10.2678C13.5356 10.4999 13.26 10.6841 12.9567 10.8097C12.6534 10.9353 12.3283 11 12 11C11.337 11 10.7011 10.7366 10.2322 10.2678C10.0001 10.0356 9.81594 9.76002 9.6903 9.45671C9.56466 9.15339 9.5 8.8283 9.5 8.5C9.5 7.83696 9.76339 7.20107 10.2322 6.73223Z",
  className: "icon-primary"
});

function SvgIndividualAml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    className: "icon-primary",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualAml);
export default __webpack_public_path__ + "static/media/individual-aml.54937747.svg";
export { ForwardRef as ReactComponent };